import { render, staticRenderFns } from "./group-member-approval.vue?vue&type=template&id=7b651b55"
import script from "./group-member-approval.vue?vue&type=script&lang=js"
export * from "./group-member-approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports